import _ from 'lodash';
import { AnyAction } from 'redux';
import ShoppingCart from 'src/entities/cart/response/ShoppingCart';
import {
    FAILURE_ORDERING_CALC,
    REQUEST_ORDERING_CALC,
    SUCCESS_ORDERING_CALC,
    SUCCESS_SUBMIT_BOOKING,
} from 'src/store/cart/actions';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';

/**
 * Reducer that manages the state of shopping cart
 */
function cartReducer(state: SingleEntityState<ShoppingCart> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_ORDERING_CALC:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORDERING_CALC:
            return _.assign({}, state, {
                isFetching: false,
                content: { ...action.response.data, containsOrderDirectlyProduct: action.containsOrderDirectlyProduct },
                error: undefined,
            });
        case SUCCESS_SUBMIT_BOOKING:
            return _.assign({}, state, { isFetching: false, content: undefined, error: undefined });
        case FAILURE_ORDERING_CALC:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}

export default cartReducer;
